// Shared X-icon close button for ConfirmModal and GalleryModal. className is append-only
// (position); appearance replaces DEFAULT_APPEARANCE wholesale (size/colour) -- see
// src/components/README.md for why the two slots aren't both append-only.
const DEFAULT_APPEARANCE = 'w-6 h-6 text-brand-muted hover:text-brand-dark'
// The Flip template pop-up's X (Cong, letter 99, 2.6): #17270D at rest, #328C12 on hover. Passed as
// `appearance` by the Flip pop-ups and ConfirmModal's `frame` layout only; other modals keep the default.
export const DARK_APPEARANCE = 'w-6 h-6 text-brand-dark hover:text-brand-hover'

// span/stroke: the X's arm length and stroke width. Defaults are the original 12px/1.5 glyph; the
// SOW 3 popup frames draw a 16px X with Figma's default 1px stroke.
export default function CloseIconButton({ onClick, className = '', appearance = DEFAULT_APPEARANCE, ariaLabel, span = 12, stroke = 1.5 }) {
  const box = span + 2
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={`flex items-center justify-center ${appearance} transition-colors ${className}`}
    >
      <svg width={box} height={box} viewBox={`0 0 ${box} ${box}`} fill="none">
        <path d={`M1 1l${span} ${span}M${span + 1} 1L1 ${span + 1}`} stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" />
      </svg>
    </button>
  )
}
